import React from 'react';
import { Clock, Calendar } from 'lucide-react';
import { format } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar as CalendarPicker } from '../ui/calendar';

const SchedulePanel = ({ showSchedule, onToggle, scheduledAt, onDateChange, scheduledTime, onTimeChange }) => {
  return (
    <Card className="border-slate-100">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-semibold flex items-center gap-2">
            <Clock className="h-4 w-4" />
            Schedule
          </CardTitle>
          <Switch
            checked={showSchedule}
            onCheckedChange={onToggle}
            data-testid="schedule-toggle"
          />
        </div>
      </CardHeader>
      {showSchedule && (
        <CardContent className="pt-0 space-y-3">
          <div>
            <Label className="text-sm text-slate-600 mb-1 block">Date</Label>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant="outline"
                  className="w-full justify-start text-left font-normal"
                  data-testid="date-picker-btn"
                >
                  <Calendar className="h-4 w-4 mr-2" />
                  {scheduledAt ? format(scheduledAt, 'PPP') : 'Pick a date'}
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0" align="start">
                <CalendarPicker
                  mode="single"
                  selected={scheduledAt}
                  onSelect={onDateChange}
                  initialFocus
                  fromDate={new Date()}
                />
              </PopoverContent>
            </Popover>
          </div>
          <div>
            <Label className="text-sm text-slate-600 mb-1 block">Time</Label>
            <Input
              type="time"
              value={scheduledTime}
              onChange={(e) => onTimeChange(e.target.value)}
              data-testid="time-input"
            />
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default SchedulePanel;
